import { Grid } from "@mui/material";
import { FC } from "react";
import FilterCancelIcon from "../styled/filter.cancel.icon";

interface ISearchFilterTabs {
    filterTabsArray: Array<{ id: string; name: string; value: string }>;
    removeFilterTab: Function;
}

const SearchFilterTabs: FC<ISearchFilterTabs> = (props: ISearchFilterTabs) => {
    return (
        <Grid
            className="wallet-filter-tab-container"
            style={props.filterTabsArray.length > 0 ? { marginTop: "10px" } : { marginTop: "5px" }}
        >
            {props.filterTabsArray.map((filterTab) => (
                <Grid key={filterTab.id} className="wallet-filter-tab-element font-style">
                    <span>{filterTab.name}</span>:
                    <span
                        style={{
                            fontWeight: "700",
                            fontSize: "16px",
                            padding: "0 5px",
                        }}
                    >
                        {filterTab.value}
                    </span>
                    <button
                        className="wallet-filter-tab-button"
                        onClick={() => props.removeFilterTab(filterTab.name, filterTab.id)}
                    >
                        <FilterCancelIcon />
                    </button>
                </Grid>
            ))}
        </Grid>
    );
};

export default SearchFilterTabs;
